import React, { useEffect, useState } from 'react';
import { Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, InputAdornment } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';


const CssTextField = withStyles({
    root: {
      '& label.Mui-focused': {
        color: '#3FA7D6',
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: '#3FA7D6',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'lightblue',
        },
        '&:hover fieldset': {
          borderColor: '#3FA7D6',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#3FA7D6',
        },
      },
    },
  })(TextField);

const FinalDets = (props) => {

    const [billableByDefault, setBillableByDefault] = useState(true);
    const [taskTravelTimeEnabled, setTaskTravelTimeEnabled] = useState(false);
    const [taskExpensesEnabled, setTaskExpensesEnabled] = useState(false);

    useEffect(() => {
        let billableByDefault = true;
        let billableByDefaultSetting = props.user ? props.user.comp_settings.find((setting) => setting.feature_id === 56) : false;
        // console.log(billableByDefaultSetting)
        if (!!billableByDefaultSetting && !billableByDefaultSetting?.feature_value) {
            billableByDefault = false;
        }
        setBillableByDefault(billableByDefault);
        
        // Check if travel time is enabled (feature_id 81)
        let travelTimeSetting = props.user ? props.user.comp_settings.find((setting) => setting.feature_id === 81) : false;
        if (!!travelTimeSetting && travelTimeSetting?.feature_value === 'true') {
            setTaskTravelTimeEnabled(true);
        }
        
        // Check if expenses are enabled (feature_id 82)
        let expensesSetting = props.user ? props.user.comp_settings.find((setting) => setting.feature_id === 82) : false;
        if (!!expensesSetting && expensesSetting?.feature_value === 'true') {
            setTaskExpensesEnabled(true);
        }
    }, [])

    let empList = null
    if (props.edit) {
        // empList = props.empList.map((emp, index) => <option key={index} value={emp.emp_id}>{emp.emp_first_name + " " + emp.emp_last_name}</option>)
        empList = props.empList.map((emp, index) => {return {value:emp.emp_id,title: emp.emp_first_name + " " + emp.emp_last_name}})
    } else {
        // empList = props.empList.map((emp, indx) => <option key={indx} value={emp.id}>{emp.employee_name}</option>)
        empList = props.empList.map((emp, indx) => { 
            // console.log(emp)
            if(!!emp){
                return { value:emp.id,title: emp.employee_name
                }
            }
           else{
                return null
            }
        }).filter((em)=> !!em)
    }
    return (
        <div className='mx-3'>

        <Autocomplete
            id="tAssTo"
            value={empList.find((emp)=> emp.value === props.formVals.tAssTo) || null}
            className={`my-3 w-100`}
                onChange={(e, newValue)=> {
                console.log(newValue)

                let value = empList.find((emp)=> emp.title === newValue.title)
                // console.log(value)
                if(!!value){
                    props.handleProjLoc(value.value, 'tAssTo')
                    props.handleProjLoc(props.empList.filter(emp => !!emp).find(emp => emp.id === newValue.value)?.emp_timezone || '', 'task_emp_timezone')
                    // props.handleBasicDetsChange(e)
                }
                return
                
            }}
            options={empList}
            getOptionLabel={(option) => option.title}
            // style={{ width: 450 }}
            renderInput={(params) => <CssTextField {...params} label="ASSIGNED TO *" variant="outlined" />}
        />
            <FormControl component="fieldset" sx={{ mt: 2 }}>
                <FormLabel component="legend">PRIORITY <span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span></FormLabel>
                <RadioGroup
                    row
                    name="tPriority"
                    value={props.formVals.tPriority}
                    onChange={(e) => props.handleFinalDetsChange({ target: { id: 'radio' + e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1), name: 'tPriority', value: e.target.value } })}
                >
                    <FormControlLabel value="Low" control={<Radio id="radioLow" />} label="Low" />
                    <FormControlLabel value="Med" control={<Radio id="radioMed" />} label="Medium" />
                    <FormControlLabel value="High" control={<Radio id="radioHigh" />} label="High" />
                </RadioGroup>
            </FormControl>

            <FormControl component="fieldset" sx={{ mt: 2 }}>
                <FormLabel component="legend">BILLABLE TO CUSTOMER <span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span></FormLabel>
                <RadioGroup
                    row
                    name="tIsBillable"
                    value={billableByDefault === true ? "yes" : "no"}
                    onChange={(e) => {
                        const isYes = e.target.value === "yes";
                        const syntheticEvent = { target: { id: isYes ? 'radioBillYes' : 'radioBillNo', name: 'tIsBillable' } };
                        console.log(syntheticEvent.target.id);
                        props.handleFinalDetsChange(syntheticEvent);
                        setBillableByDefault(isYes);
                    }}
                >
                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
            </FormControl>

            <FormControl component="fieldset" sx={{ mt: 2 }}>
                <FormLabel component="legend">SIGNATURE REQUIRED <span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span></FormLabel>
                <RadioGroup
                    row
                    name="tSigReq"
                    value={props.formVals.tSigReq === 1 ? "yes" : "no"}
                    onChange={(e) => props.handleFinalDetsChange({ target: { id: e.target.value === "yes" ? 'radioSigYes' : 'radioSigNo', name: 'tSigReq' } })}
                >
                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                    <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
            </FormControl>

            <Autocomplete
                id="tContacts"
                className={`my-3 w-100`}
                multiple
                value={props?.formVals?.tContacts}
                options={props?.contactList || []}
                renderInput={(params) => <CssTextField {...params} label="CONTACTS" variant="outlined" />}
                onChange={(event, value) => props.handleFinalDetsChange({ target: { id: 'tContacts', value: value } })}
                onSelect={(e)=> {console.log(props?.contactList)}}
            />
            <TextField id="tNotes" label="Notes" variant="outlined" style={{ marginBottom: '20px', width: '100%' }}
                value={props.formVals.tComment}
                onChange={(event) => props.handleFinalDetsChange(event)}
                multiline
                minRows={4}
                renderInput={(params) => <CssTextField {...params} label="ASSIGNED TO *" />}
                inputProps={{ maxLength: 4000 }}
            />
            {taskTravelTimeEnabled && (
                <CssTextField
                    id="tTravelTime"
                    label="TRAVEL TIME (Duration)"
                    type="text"
                    variant="outlined"
                    style={{ marginBottom: '20px', width: '100%' }}
                    value={props.formVals.tTravelTime || ''}
                    onChange={(event) => props.handleFinalDetsChange(event)}
                    placeholder="HH:MM (e.g., 02:30 for 2 hours 30 minutes)"
                    helperText="Enter duration in HH:MM format"
                    inputProps={{
                        pattern: "[0-9]{1,3}:[0-5][0-9]",
                    }}
                />
            )}

            {taskExpensesEnabled && (
                <CssTextField
                    id="tExpenses"
                    label="EXPENSES"
                    type="number"
                    variant="outlined"
                    style={{ marginBottom: '20px', width: '100%' }}
                    value={props.formVals.tExpenses || ''}
                    onChange={(event) => props.handleFinalDetsChange(event)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    }}
                    inputProps={{
                        min: 0,
                        step: 0.01,
                    }}
                    placeholder="0.00"
                />
            )}
            {/*}
             <Form.Group as={Col} controlId="tComment">
                <Form.Label>NOTES</Form.Label><span><i style={{margin: 5,fontSize: '0.7rem'}} className="fas fa-asterisk text-danger"></i></span>
                <Form.Control value={props.formVals.tComment} type="text" onChange={props.handleFinalDetsChange} required />
            </Form.Group>
             */}
            {/*<CssTextField
                className={`my-3 w-100`}
                label="NOTES/COMMENTS"
                value={props.formVals.tComment}
                onChange={props.handleFinalDetsChange} 
                variant="outlined"
                id="tComment"
            />*/}

            {props.isCreatingTask && (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '30px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    marginBottom: '20px'
                }}>
                    <CircularProgress size={40} style={{ marginBottom: '15px' }} />
                    <p style={{ margin: 0, fontSize: '1.1rem', fontWeight: '500', color: '#495057' }}>
                        Creating Task(s)...
                    </p>
                </div>
            )}

            <Button 
                className={`w-100`} 
                variant="contained" 
                type="submit"
                disabled={props.isCreatingTask}
            >
                {props.edit ? "Submit" : "Create Task"}
            </Button>
        </div>
    )
};

export default FinalDets;